import {ViewportState} from '@/stores/ViewportStore/ViewportStore.types';

import {Store} from '@/stores/Store';

const initialViewportState: ViewportState = {
  isStatisticInView: false,
};

export class ViewportStore extends Store<ViewportState> {
  constructor() {
    super(initialViewportState);
  }

  public setStatisticInViewState = (isInView: boolean): void => {
    this.setState({
      ...this.getState(),
      isStatisticInView: isInView,
    });
  };

  public getStatisticInViewState = (): boolean => {
    return this.getState().isStatisticInView;
  };
}
